module.exports = __webpack_public_path__ + "static/media/tsb3kz.0face661.pdf";